import * as React from "react";
import { Util } from "@grandvisionhq/common";
import { resilientFetch, isArray, isString } from "@grandvisionhq/utils";
import { validateSchema } from "./schema-validator.js";
const fetch = resilientFetch();
const mapRelatedLinksToLink = (relatedLink) => {
  return {
    label: relatedLink["eyewear:categoryRelatedLinkName"],
    href: relatedLink["eyewear:categoryRelatedLinkUrl"]
  };
};
const WORD_LIFT_RELATED_LINKS_API_URL = "https://api.wordlift.io/data/";
const prepareUrl = (url) => {
  const parsed = new URL(url);
  const protocol = parsed.protocol.replace(":", "");
  return `${protocol}/${parsed.hostname}${parsed.pathname}`;
};
const normalizeLink = (link) => {
  const labels = isArray(link.label) ? link.label : [link.label];
  const hrefs = isArray(link.href) ? link.href : [link.href];
  return labels.map((label, i) => ({ label, href: hrefs[i] })).filter(
    (item) => isString(item.label) && isString(item.href) && !!item.label && !!item.href
  );
};
const useWordLiftRelatedLinks = () => {
  const [relatedLinks, setRelatedLinks] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [rawResult, setRawResult] = React.useState("");
  const fetchRelatedLinks = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const currentUrl = prepareUrl(window.location.href);
      const res = await fetch(`${WORD_LIFT_RELATED_LINKS_API_URL}${currentUrl}`);
      if (!res.ok) {
        throw new Error("Failed to fetch links");
      }
      const text = await res.text();
      if (!text.length) {
        setRelatedLinks([]);
        return;
      }
      const data = JSON.parse(text);
      const validatedJson = validateSchema(data).value();
      const parsedLinks = validatedJson[0]?.["eyewear:categoryRelatedLinks"].map(mapRelatedLinksToLink).flatMap(normalizeLink).map((link) => ({ ...link, label: Util.truncateString(link.label, 19) })).slice(0, 8) ?? [];
      setRelatedLinks(parsedLinks);
      setRawResult(text);
    } catch (err) {
      console.error("Unable to validate json", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);
  return { relatedLinks, loading, error, fetchRelatedLinks, rawResult };
};
export {
  useWordLiftRelatedLinks
};
//# sourceMappingURL=use-wordlift-related-links.js.map
